import { render, staticRenderFns } from "./OnboardStep.vue?vue&type=template&id=49bfbba8&scoped=true"
import script from "./OnboardStep.vue?vue&type=script&lang=js"
export * from "./OnboardStep.vue?vue&type=script&lang=js"
import style0 from "./OnboardStep.vue?vue&type=style&index=0&id=49bfbba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bfbba8",
  null
  
)

export default component.exports